import type { InputHTMLAttributes } from "react";

import { cn } from "../../lib/utils";

export function Input({ className, type, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      type={type}
      className={cn(
        "h-12 w-full rounded-xl border border-input bg-card px-3.5 text-sm text-foreground shadow-[0_1px_0_rgba(13,29,38,0.03)] transition-colors placeholder:text-muted-foreground/75 hover:border-foreground/30 focus-visible:border-ring disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-70 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/15",
        className,
      )}
      {...props}
    />
  );
}
